import { Routes, Route } from "react-router";
import DealersMain from "Modules/dealers/views/main";
import DealerOverview from 'Modules/dealers/views/overview';
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const DealersView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "dea") && <Route path="list" element={<DealersMain />} />}
                {HasPermission(user, "dea") && <Route path="overview/:id" element={<DealerOverview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default DealersView;